import { Expose } from 'class-transformer';

export class ChangePasswordEmailDTO {
  @Expose({ name: "old_password" })
  public oldPassword!: string;

  public password!: string;
  public email!: string;
}

export class ChangePasswordTokenDTO {
  public password!: string;
  public token!: string;
}


export class GenericMessage {
  public message!: string;
}
